import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import _ from "lodash";
import { Modal, Button, Icon, Tooltip, Popconfirm, Empty, message } from "antd";
import { UnlockOutlined, LockOutlined } from "@ant-design/icons";
import Table from "../../../components/Table";
import Subtitle from "../../../components/Subtitle";
import Loading from "../../../components/Loading";
import { createLoadingSelector } from "../../../store/api/selectors";
import { numberToReal, padLeadingZeros } from "../../../helpers/functions";
import { getProducts as getPisCofins } from "../Classify/PisCofins/actions";
import { getProducts as getIcms } from "../Classify/Icms/actions";
import {
  checkAllReprocess,
  reprocessResult,
  blockCompetence,
  checkReprocess,
  deleteResult,
  getResults,
  downloadRelatorioResultados,
  acceptNextDuplicated,
  acceptNextClassify,
  notificarNovoResultado,
} from "./actions";
import { Sessao } from "../../../helpers/Token";

const { confirm } = Modal;
const ButtonGroup = Button.Group;

const initModal = {
  period: { month: null, year: null },
  status: null,
  content: "",
  show: false,
  action: null,
};

const subtitle = [
  { icon: "eye", description: "Visualizar resultado" },
  { icon: "table", description: "Visualizar detalhamento" },
  { icon: "warning", description: "Pendência encontrada no resultado" },
  { icon: "reload", description: "Reprocessar resultado" },
  { icon: "delete", description: "Deletar resultado" },
  { icon: 'UnlockOutlined', description: "Bloquear resultado" },
  { icon: "LockOutlined", description: "Desbloquar resultado" },
];

const planoTeste = Sessao('planoTeste');
const planoRecuperadorLimitado = Sessao('planoRecuperadorLimitado');

class Result extends Component {
  state = {
    cnpj: JSON.parse(sessionStorage.getItem("eRecuperadorCompany")).Cnpj,
    currentPage: 1,
    currentPageSize: 12,
    modalPendency: { ...initModal },
    checkAllReprocess: false,
    icmsModule: JSON.parse(sessionStorage.getItem("icmsModule")),
    isNotificando: false,
  };

  componentDidMount() {
    const { props } = this;
    props.getResults();

    if (props.location.state) {
      this.setState({ currentPage: props.location.state.currentPage || 1 })
      this.setState({ currentPageSize: props.location.state.currentPageSize || 12 })
    }
  }

  componentDidUpdate(prevProps) {
    const {
      props,
      props: { status, results, mensagem },
    } = this;

    if (status === 200) {
      props.getResults();
    }

    if (
      prevProps.results !== results &&
      (prevProps.results.length || results.length)
    ) {
      this.updateAllChecked();

      this.setState({
        cnpj: JSON.parse(sessionStorage.getItem("eRecuperadorCompany")).Cnpj,
      });
    }
  }

  updateAllChecked = () => {
    const { results } = this.props;
    const checkAllReprocess = results.some(
      (item) => !item.resultadoPisCofins.Reprocessar
    );
    this.setState({ checkAllReprocess });
  };

  setCurrentPage = (page) => {
    this.setState({ currentPage: page || 1 });
  }

  setCurrentPageSize = (size) => {
    this.setState({ currentPageSize: size || 12 });
  }

  actionGrid(record) {
    const { deleteResult, reprocessResult, blockCompetence } = this.props;
    const { Id, IdControleApuracao} = record;

    return (
      <Button.Group>
        {this.renderOtherActions(record)}

        <Tooltip title="Reprocessar"> 
          <Popconfirm
            title={<span>Esta opção irá reprocessar está competência.</span>}
            okText="Ok"
            cancelText="Cancelar"
            onConfirm={() => reprocessResult(Id)}
            disabled={(record.ControleApuracao.ApuracaoBloqueada)}
          >
            <Button className="btn-ghost" icon="reload" disabled={(record.ControleApuracao.ApuracaoBloqueada)}/>
          </Popconfirm>
        </Tooltip>

        {(planoTeste === true || planoRecuperadorLimitado === true) ? "" :
          <Tooltip title="Excluir">
            <Popconfirm
              title={
                <span>
                  Esta opção irá interromper o processo de apuração, <br />
                  apagando os dados desta competência.
                </span>
              }
              okText="Ok"
              cancelText="Cancelar"
              onConfirm={() => deleteResult(Id)}
            >
              <Button type="danger" icon="delete" ghost />
            </Popconfirm>
          </Tooltip>
        }

        <Tooltip title={`${record.ControleApuracao.ApuracaoBloqueada ? 'Descongelar' : 'Congelar'}`}>
          <Popconfirm
            title={<span>Esta opção irá {record.ControleApuracao.ApuracaoBloqueada ? 'descongelar' : 'congelar'} os resultados desta competência.</span>}
            okText="Ok"
            cancelText="Cancelar"
            onConfirm={() => blockCompetence(IdControleApuracao, record.ControleApuracao.ApuracaoBloqueada)}
          >
            <Button className="btn-ghost" style={{ paddingLeft: '9px', paddingRight: '9px' }} >{record.ControleApuracao.ApuracaoBloqueada ? <LockOutlined /> : <UnlockOutlined />}</Button>
          </Popconfirm>
        </Tooltip>

      </Button.Group>
    );
  }

  doNotificarNovoResultado(idImportacao) {
    this.setState({ isNotificando: true });
    notificarNovoResultado(idImportacao)
      .then(() => {
        message.success("Notificação enviada com sucesso!");
      })
      .finally(() => this.setState({ isNotificando: false }));
  }

  renderOtherActions(record) {
    const { history } = this.props;
    const { cnpj, isNotificando } = this.state;
    const {
      ExisteProduto,
      ExisteMovimentacao,
      Mes,
      Ano,
    } = record.ControleApuracao;
    const { Id, Movimentacao, Importacao = {} } = record;
    const modalContent = {
      classify: {
        pis:
          "O sistema detectou itens sem a devida classificação fiscal de PIS e COFINS ou com a classificação fora do período de vigência.",
        icms:
          "O sistema detectou itens sem a devida classificação fiscal de ICMS ou com a classificação fora do período de vigência.",
      },
      duplicity: {
        pis:
          "Existem produtos que contém o mesmo código e classificações de PIS e COFINS diferentes para o mesmo período.",
        icms:
          "Existem produtos que contém o mesmo código e classificações de ICMS diferentes para o mesmo período.",
      },
    };
    let pendency = {
      period: { month: Mes, year: Ano },
      status: Movimentacao && Movimentacao.Status,
      title: "",
      content: "",
      action: null,
      isIcms: false,
    };

    // NORMAL
    if (!Movimentacao || Movimentacao.Status === 0) {
      let btnNotificarEMultiplicador = ExisteProduto &&
        ExisteMovimentacao &&
        Importacao.Origem === "eMultiplicador" && (
          <Tooltip title="Notificar novo resultado gerado">
            <Button
              type="primary"
              icon="notification"
              ghost
              loading={isNotificando}
              onClick={() => this.doNotificarNovoResultado(Importacao.Id)}
            />
          </Tooltip>
        );

      if (record.StatusExecucao === 2) {
        return (
          <>
            <Tooltip title="Visualizar Detalhamento">
              <Button
                type="primary"
                icon="table"
                ghost
                disabled={!(ExisteProduto && ExisteMovimentacao)}
                onClick={() => history.push({
                  pathname: `/empresa/${cnpj}/resultado/${Id}`,
                  state: { currentPage: this.state.currentPage, currentPageSize: this.state.currentPageSize }
                })}
              />
            </Tooltip>
            {btnNotificarEMultiplicador}
          </>
        );
      } else {
        return (
          <>
            <Tooltip title="Visualizar">
              <Button
                type="primary"
                icon="eye"
                ghost
                disabled={!(ExisteProduto && ExisteMovimentacao)}
                onClick={() => history.push({
                  pathname: `/empresa/${cnpj}/resultado/${Id}`,
                  state: { currentPage: this.state.currentPage, currentPageSize: this.state.currentPageSize }
                })}
              />
            </Tooltip>
            {btnNotificarEMultiplicador}
          </>
        );
      }
    }

    // DIVERGENCIA
    if (Movimentacao) {
      const { Status } = Movimentacao;

      if (Status === 3 || Status === 5 || Status === 7) {
        pendency = {
          ...pendency,
          title: "Produtos sem classificação",
          action: this.props.acceptNextClassify,
        };
      }
      if (Status === 4 || Status === 6 || Status === 8) {
        pendency = {
          ...pendency,
          title: "Duplicidade na classificação de produtos",
          action: this.props.acceptNextDuplicated,
        };
      }

      if (Status === 3) {
        return (
          <Tooltip title="O sistema detectou itens sem a devida classificação fiscal.">
            <Button
              className="btn-ghost btn-warning"
              icon="warning"
              ghost
              onClick={() =>
                this.openModalPendency(
                  pendency,
                  pendency.status,
                  modalContent.classify.pis,
                  false
                )
              }
            />
          </Tooltip>
        );
      }

      if (Status === 5) {
        return (
          <Tooltip title="O sistema detectou itens sem a devida classificação fiscal de icms.">
            <Button
              className="btn-ghost btn-warning"
              icon="warning"
              ghost
              onClick={() =>
                this.openModalPendency(
                  pendency,
                  pendency.status,
                  modalContent.classify.icms,
                  true
                )
              }
            />
          </Tooltip>
        );
      }

      if (Status === 7) {
        return (
          <Tooltip title="O sistema detectou itens sem a devida classificação fiscal de icms e pis/cofins">
            <Button
              className="btn-ghost btn-warning"
              icon="warning"
              ghost
              onClick={() =>
                this.chooseTypePendency(
                  pendency,
                  pendency.status,
                  modalContent.classify
                )
              }
            />
          </Tooltip>
        );
      }

      if (Status === 1 || Status === 65 || Status === 66) {
        return (
          <Tooltip title="Itens com pendência">
            <Button
              className="btn-ghost btn-warning"
              icon="warning"
              ghost
              onClick={() => this.modalDelete(Id, Status)}
            />
          </Tooltip>
        );
      }

      if (Status === 4) {
        return (
          <>
            <Tooltip title="O sistema detectou o mesmo código de item com mais de uma classificação fiscal.">
              <Button
                className="btn-ghost btn-warning"
                icon="warning"
                ghost
                onClick={() =>
                  this.openModalPendency(
                    pendency,
                    pendency.status,
                    modalContent.duplicity.pis,
                    false
                  )
                }
              />
            </Tooltip>
          </>
        );
      }

      if (Status === 6) {
        return (
          <>
            <Tooltip title="O sistema detectou o mesmo código de item com mais de uma classificação fiscal de icms.">
              <Button
                className="btn-ghost btn-warning"
                icon="warning"
                ghost
                onClick={() =>
                  this.openModalPendency(
                    pendency,
                    pendency.status,
                    modalContent.duplicity.icms,
                    true
                  )
                }
              />
            </Tooltip>
          </>
        );
      }

      if (Status === 8) {
        return (
          <>
            <Tooltip title="O sistema detectou o mesmo código de item com mais de uma classificação fiscal de icms e pis/cofins.">
              <Button
                className="btn-ghost btn-warning"
                icon="warning"
                ghost
                onClick={() =>
                  this.chooseTypePendency(
                    pendency,
                    pendency.status,
                    modalContent.duplicity
                  )
                }
              />
            </Tooltip>
          </>
        );
      }
    }
  }

  renderCalculation(text, record, isAudit = false, isCredit = false) {
    const { Movimentacao, ControleApuracao } = record;
    if (isAudit) {
      if (record.StatusExecucao === 2) {
        return "-";
      } else {
        if (Movimentacao) {
          if (
            Movimentacao.Status === 1 ||
            Movimentacao.Status === 3 ||
            Movimentacao.Status === 4 ||
            !ControleApuracao.ExisteApuracao
          ) {
            return "Resolver pendência";
          } else {
            return numberToReal(text);
          }
        }
      }
      return "Resolver pendência";
    } else if (isCredit) {
      if (record.StatusExecucao === 2) {
        return "-";
      } else {
        if (Movimentacao) {
          if (
            Movimentacao.Status === 1 ||
            Movimentacao.Status === 3 ||
            Movimentacao.Status === 4 ||
            !ControleApuracao.ExisteApuracao
          ) {
            return "Resolver pendência";
          } else {
            return numberToReal(text);
          }
        }
      }
      return "Resolver pendência";
    } else {
      if (Movimentacao) {
        if (
          Movimentacao.Status === 1 ||
          Movimentacao.Status === 3 ||
          Movimentacao.Status === 4 ||
          !ControleApuracao.ExisteApuracao
        ) {
          return "Resolver pendência";
        } else {
          return numberToReal(text);
        }
      }
      return "Resolver pendência";
    }
  }

  onChangeReprocess = (id) => {
    this.props.checkReprocess(id);
  };

  modalError = (month, year, status) => {
    confirm({
      title: "Classificações pendentes",
      content:
        "Existem produtos sem classificação tributária para a competência selecionada.",
      okType: "danger",
      okText: "Corrigir",
      cancelText: "Cancelar",
      onOk: () => {
        this.props.backToClassify(month, year, status);
      },
    });
  };

  modalDelete = (Id, Status) => {
    confirm({
      title: "Excluir resultado",
      content:
        Status === 65
          ? "Não foi possível gerar resultados para este período de apuração. Não detectamos movimentação de saída nos documentos fiscais e/ou obrigações acessórias."
          : Status === 66
            ? "Não foi possível gerar resultados para este período de apuração. CFOP identificado nos documentos fiscais não está configurado como considera receita nas informações cadastrais."
            : "Não foi possível gerar resultados para este período de apuração. Detectamos em seu arquivo magnético somente detalhamento das ENTRADAS. Para gerar resultados no e-Recuperador é necessário carregar arquivos que contenham movimentação de SAÍDA. Para maiores informações, consulte o Manual do Usuário – item 2.2.4.1 – 'Arquivos aceitos pelo sistema'.",
      okType: "danger",
      okText: "Excluir",
      cancelText: "Cancelar",
      onOk: () => {
        this.props.deleteResult(Id);
      },
    });
  };

  chooseTypePendency(propsModal, status, content) {
    let newStatus = { pis: null, icms: null };
    if (status === 7) {
      newStatus = { pis: 3, icms: 5 };
    } else if (status === 8) {
      newStatus = { pis: 4, icms: 6 };
    }

    confirm({
      title: "Qual tipo de classificação deseja corrigir?",
      okText: "ICMS/ICMS ST",
      cancelText: "PIS/COFINS",
      okType: "default",
      onOk: () =>
        this.openModalPendency(propsModal, newStatus.icms, content.icms, true),
      onCancel: () =>
        this.openModalPendency(propsModal, newStatus.pis, content.pis, false),
    });
  }

  openModalPendency = (propsModal, status, content, isIcms) => {
    this.setState({
      modalPendency: { ...propsModal, status, content, isIcms, show: true },
    });
  };

  resetModalPendency = () => {
    this.setState({ modalPendency: { ...initModal } });
  };

  baixarRelatorio(isPDF) {
    this.props.downloadRelatorioResultados(isPDF);
  }

  render() {
    const { results, isFetching, isProcessando } = this.props;
    const { modalPendency, icmsModule } = this.state;

    const columns = [
      {
        title: "Competência",
        dataIndex: "ControleApuracao.Mes",
        width: 160,
        render: (text, record) => {
          const { Ano, Mes } = record.ControleApuracao;
          return `${padLeadingZeros(Mes, 2)}/${Ano}`;
        },
      },
      {
        title: "extrato do simples (declarado)",
        dataIndex: "ControleApuracao.ExisteExtratoSimplesNacional",
        width: 260,
        align: "center",
        render: (text, record) => {
          const { ExisteExtratoSimplesNacional } = record.ControleApuracao;
          return (
            <Icon
              className={
                ExisteExtratoSimplesNacional ? "text-success" : "text-danger"
              }
              type={
                ExisteExtratoSimplesNacional ? "check-circle" : "close-circle"
              }
            />
          );
        },
      },
      {
        title: "sintegra/sped fiscal/df-e",
        dataIndex: "ControleApuracao.ExisteMovimentacao",
        width: 220,
        align: "center",
        render: (text) => {
          return (
            <Icon
              className={text ? "text-success" : "text-danger"}
              type={text ? "check-circle" : "close-circle"}
            />
          );
        },
      },
      {
        title: "total pago pis/cofins",
        dataIndex: "ValorPagoDeclarado",
        width: 210,
        align: "center",
        render: (text) => numberToReal(text),
      },
      {
        title: "total auditado pis/cofins",
        dataIndex: "ValorAuditado",
        width: 230,
        align: "center",
        render: (text, record) => this.renderCalculation(text, record, true),
      },
      {
        title: "crédito a restituir pis/cofins",
        dataIndex: "ValorCreditoRecuperar",
        width: 260,
        align: "center",
        render: (text, record) =>
          this.renderCalculation(text, record, false, true),
      },
      {
        title: () => {
          return <Subtitle data={subtitle} />;
        },
        fixed: icmsModule || window.innerWidth < 1900 ? "right" : false,
        width: 140,
        align: "center",
        render: (text, record) =>
          isProcessando ? (
            <Tooltip title="Botões inativos por ter documentos em processamento">
              <Button type="link" loading={isProcessando} />
            </Tooltip>
          ) : (
            this.actionGrid(record)
          ),
      },
    ];

    if (icmsModule) {
      columns.splice(4, 0, {
        title: "total pago icms",
        dataIndex: "ValorPagoDeclaradoIcms",
        width: 140,
        align: "center",
        render: (text) => numberToReal(text),
      });
      columns.splice(6, 0, {
        title: "total auditado icms",
        dataIndex: "ValorAuditadoIcms",
        width: 160,
        align: "center",
        render: (text, record) => this.renderCalculation(text, record),
      });
      columns.splice(8, 0, {
        title: "crédito a restituir icms",
        dataIndex: "ValorCreditoRecuperarIcms",
        width: 190,
        align: "center",
        render: (text, record) => this.renderCalculation(text, record),
      });
    }

    let data = _.map(results, (r) => {
      return {
        ...r.resultadoPisCofins,
        id: r.resultadoPisCofins.Id,
        classificacaoDiferente: r.ClassificacaoDiferente,
      };
    });
    data = _.sortBy(data, ["ControleApuracao.Ano", "ControleApuracao.Mes"]);

    return (
      <>
        {isFetching ? <Loading text="Carregando resultados" /> : null}

        <Modal
          visible={modalPendency.show}
          title={modalPendency.title}
          closable={false}
          footer={false}
        >
          <div className="row">
            <div className="col-md-12">
              <p>{modalPendency.content}</p>
              <p className="mt-2">
                Ao clicar em prosseguir você concorda que o sistema irá
                considerar os itens duplicados como TRIBUTADOS.
              </p>
            </div>
            <div className="col-md-12">
              <div className="ant-modal-footer mt-3">
                <Button
                  type="danger"
                  ghost
                  onClick={() => this.resetModalPendency()}
                >
                  Cancelar
                </Button>
                <Button
                  type="primary"
                  ghost
                  onClick={() => {
                    this.props.backToClassify(
                      modalPendency.period.month,
                      modalPendency.period.year,
                      modalPendency.status
                    );
                    this.resetModalPendency();
                  }}
                >
                  Corrigir
                </Button>
                <Button
                  type="btn-ghost btn-success"
                  onClick={() => {
                    modalPendency.action(
                      modalPendency.period.month,
                      modalPendency.period.year,
                      modalPendency.isIcms
                    );
                    this.resetModalPendency();
                  }}
                >
                  Prosseguir
                </Button>
              </div>
            </div>
          </div>
        </Modal>

        {results.length ? (
          <div>
            <Tooltip
              title={
                isProcessando &&
                "Funcionalidade desabilitada por ter documentos em processamento"
              }
            >
              <ButtonGroup>
                <Button
                  type="primary"
                  loading={this.props.loadingPDF}
                  disabled={isProcessando}
                  onClick={() => this.baixarRelatorio(true)}
                >
                  {this.props.loadingPDF ? null : <Icon type="file-pdf" />}
                  Exportar PDF
                </Button>

                <Button
                  type="primary"
                  loading={this.props.loadingExcel}
                  disabled={isProcessando}
                  onClick={() => this.baixarRelatorio(false)}
                >
                  {this.props.loadingExcel ? null : <Icon type="file-excel" />}
                  Exportar Excel
                </Button>
              </ButtonGroup>
            </Tooltip>

            <Table
              columns={columns}
              data={data}
              pageSizeOptions={["12", "36", "60", "96"]}
              scroll={{ x: 1400, y: "calc(100vh - 355px)" }}
              pageChange={this.setCurrentPage}
              pageNumberDefault={this.state.currentPage}
              pageSizeDefault={this.state.currentPageSize}
              pageSizeChange={this.setCurrentPageSize}
            />
          </div>
        ) : (
          <Empty
            image={Empty.PRESENTED_IMAGE_SIMPLE}
            description="Nenhum arquivo foi enviado para apuração"
          />
        )}
      </>
    );
  }
}

const loadingResults = createLoadingSelector(["GET_RESULTS"]),
  loadingProducts = createLoadingSelector(["GET_PRODUCTS"]),
  loadingAcceptDuplicated = createLoadingSelector(["ACCEPT_DUPLICATED"]),
  loadingDeleteResult = createLoadingSelector(["DELETE_RESULT"]),
  loadingBlockCompetence = createLoadingSelector(["BLOCK_COMPETENCE"]);

const mapStateToProps = (state) => {
  return {
    results: state.results.list.Retorno || [],
    status: state.results.status,
    mensagem: state.results.list.Mensagem,
    loadingExcel: state.results.loadingExcel,
    loadingPDF: state.results.loadingPDF,
    isProcessando: state.importacao.isProcessando,
    isFetching:
      loadingResults(state) ||
      loadingProducts(state) ||
      loadingAcceptDuplicated(state) ||
      loadingDeleteResult(state) ||
      loadingBlockCompetence(state),
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      checkAllReprocess,
      reprocessResult,
      checkReprocess,
      deleteResult,
      getPisCofins,
      getIcms,
      getResults,
      acceptNextDuplicated,
      acceptNextClassify,
      downloadRelatorioResultados,
      blockCompetence
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Result));
